export default __webpack_public_path__ + "static/youth-founders-summit-2020-2nd-place-035c3ca579aec755e1f4db50f23f4b62.png";